import React from 'react';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import ColorPalette from '../../colorpalette/ColorPalette';

/**
 * Tipos de anexo do paciente. O backend grava `kind` na linha; aqui ficam só o
 * mapeamento a partir do MIME (usado antes do envio) e a aparência de cada tipo.
 */

export const KIND_IMAGE = 'image';
export const KIND_PDF = 'pdf';
export const KIND_DOCUMENT = 'document';

const KINDS = {
    [KIND_IMAGE]: {
        kind: KIND_IMAGE,
        label: 'Imagem',
        color: ColorPalette.blueMain,
        background: ColorPalette.blueLight4
    },
    [KIND_PDF]: {
        kind: KIND_PDF,
        label: 'PDF',
        color: ColorPalette.error,
        background: ColorPalette.errorLight
    },
    [KIND_DOCUMENT]: {
        kind: KIND_DOCUMENT,
        label: 'Documento',
        color: ColorPalette.textMedium,
        background: ColorPalette.bgMedium
    }
};

/**
 * MIME → kind. Usado no preview local, antes de o backend responder.
 */
export const getKindFromMimeType = (mimeType) => {
    const type = (mimeType || '').toLowerCase();

    if (type.indexOf('image/') === 0) return KIND_IMAGE;
    if (type === 'application/pdf') return KIND_PDF;

    return KIND_DOCUMENT;
};

export const getKindInfo = (kind) => {
    return KINDS[kind] || KINDS[KIND_DOCUMENT];
};

export const isImageKind = (kind) => kind === KIND_IMAGE;

/**
 * Ícone do tipo, já com a cor certa.
 */
export const getKindIcon = (kind, fontSize = 26) => {
    const info = getKindInfo(kind);
    const style = { color: info.color, fontSize: fontSize };

    if (info.kind === KIND_IMAGE) return <ImageOutlinedIcon style={style} />;
    if (info.kind === KIND_PDF) return <PictureAsPdfOutlinedIcon style={style} />;

    return <InsertDriveFileOutlinedIcon style={style} />;
};

/**
 * Tamanho do arquivo em formato legível (pt-BR).
 */
export const formatFileSize = (bytes) => {
    const size = Number(bytes);

    if (!size || size <= 0) return '';
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(0)} KB`;

    return `${(size / (1024 * 1024)).toFixed(1).replace('.', ',')} MB`;
};
